import React, { } from 'react';
import { Header as BackstageHeader } from '@backstage/core-components';
import { Box, Typography } from '@material-ui/core';
import useStyles from './style';
import { Breadcrumbs } from '../Breadcrumbs';












export function Header(props) {
  const {
    title,
    subtitle,
    children,
    type,
    breadcrumbItems,
    pageTitleOverride,
  } = props;
  const classes = useStyles();

  return (
    React.createElement(BackstageHeader, {
      title: 
        React.createElement(Box, null
          , breadcrumbItems && React.createElement(Breadcrumbs, { items: breadcrumbItems,} )
          , React.createElement(Typography, { variant: "h3",}, title)
        )
      ,
      pageTitleOverride: pageTitleOverride || title,
      type: type,
      subtitle: 
        typeof subtitle === 'string' ? (
          React.createElement(Typography, { variant: "subtitle2", className: classes.subtitle,}
            , subtitle
          )
        ) : (
          subtitle
        )
      ,}
    
      , children
    )
  );
}
